import { UserProfile } from "../../../model/User/UserProfile";
import { map, Observable } from "rxjs";
import { apiService } from "../../ApiService";

export declare type UpdateFamilyProfileData = UserProfile & { pin?: string };

export const updateFamilyProfile = (
  profile: UpdateFamilyProfileData,
): Observable<UserProfile> => {
  return apiService
    .put<{ profile: UserProfile }>({
      path: `v1/family/profiles/${profile.id}`,
      body: {
        ...profile,
        nickname: profile.nickname,
        birthDate: profile.birthDate !== "" ? profile.birthDate : undefined,
        avatarId: profile.avatarId,
        userProfile: profile.userProfile,
        isPinLocked: profile.isPinLocked,
      },
      requiresAuthPolicy: "user",
    })
    .pipe(map(({ profile }) => profile));
};
